import { createSlice, current } from "@reduxjs/toolkit";

export interface ICommentsState {
  isLoading: boolean;
  error: string;
  success: string;
  comments: any;
  replies: any;
  isCommentAdded: boolean;
  isReplyAdded: boolean;
  isCommentDeleted: boolean;
  isReplyDeleted: boolean;
  isCommentsFetched: boolean;
}

const initialState: ICommentsState = {
  isLoading: false,
  error: "",
  success: "",
  comments: [],
  replies: [],
  isCommentAdded: false,
  isReplyAdded: false,
  isCommentDeleted: false,
  isReplyDeleted: false,
  isCommentsFetched: false,
};

export const CommentRedux: any = createSlice({
  name: "CommentRedux",
  initialState,
  reducers: {
    setCommentsState: (state: any, action: any) => {
      const newState = {
        ...state,
        [action.payload.key]: action.payload.value,
      };
      return newState;
    },
    addCommentsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isCommentAdded: false,
      };
      return newState;
    },
    addCommentsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
        isCommentAdded: true,
      };
      return newState;
    },
    addCommentsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isCommentAdded: false,
        isLoading: false,
      };
      return newState;
    },
    updateCommentRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    updateCommentSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
      };
      return newState;
    },
    updateCommentFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    deleteCommentRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isCommentDeleted: false,
      };
      return newState;
    },
    deleteCommentSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
        isCommentDeleted: true,
      };
      return newState;
    },
    deleteCommentFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isCommentDeleted: false,
        isLoading: false,
      };
      return newState;
    },
    getAllCommentsByPostIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isCommentsFetched: true,
      };
      return newState;
    },
    getAllCommentsByPostIdSuccess: (state: any, action: any) => {
      const previousComments = current(state?.comments);

      const response = action.payload?.data;

      const formatComments =
        response?.currentPage === 1 ? [] : previousComments?.responseData;

      const newState = {
        ...state,
        isLoading: false,
        isCommentsFetched: false,
        comments: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...formatComments, ...response?.responseData],
        },
      };
      return newState;
    },
    getAllCommentsByPostIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCommentsFetched: false,
      };
      return newState;
    },
    addReplyRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isReplyAdded: false,
      };
      return newState;
    },
    addReplySuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
        isReplyAdded: true,
      };
      return newState;
    },
    addReplyFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isReplyAdded: false,
        isLoading: false,
      };
      return newState;
    },
    updateReplyRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    updateReplySuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
      };
      return newState;
    },
    updateReplyFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    deleteReplyRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isReplyDeleted: false,
      };
      return newState;
    },
    deleteReplySuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
        isReplyDeleted: true,
      };
      return newState;
    },
    deleteReplyFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isReplyDeleted: false,
        isLoading: false,
      };
      return newState;
    },
    getCommentRepliesByCommentIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    getCommentRepliesByCommentIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        error: null,
        isLoading: false,
        replies: action?.payload?.data,
      };
      return newState;
    },
    getCommentRepliesByCommentIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
  },
});

export const {
  setCommentsState,

  addCommentsRequest,
  addCommentsSuccess,
  addCommentsFailure,

  updateCommentRequest,
  updateCommentSuccess,
  updateCommentFailure,

  deleteCommentRequest,
  deleteCommentSuccess,
  deleteCommentFailure,

  getAllCommentsByPostIdRequest,
  getAllCommentsByPostIdSuccess,
  getAllCommentsByPostIdFailure,

  addReplyRequest,
  addReplySuccess,
  addReplyFailure,

  updateReplyRequest,
  updateReplySuccess,
  updateReplyFailure,

  deleteReplyRequest,
  deleteReplySuccess,
  deleteReplyFailure,

  getCommentRepliesByCommentIdRequest,
  getCommentRepliesByCommentIdSuccess,
  getCommentRepliesByCommentIdFailure,
} = CommentRedux.actions;

export default CommentRedux.reducer;
